import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { checkEditorPermission } from "services/utils/HelperFunction";
import { Apply } from "./Apply";
import { History } from "./History";
import { ActiveLoans } from "./ActiveLoans";
import { themes } from "services/constants";
import ToggleButton from "@mui/material/ToggleButton";
import { setGlobalSearchValue } from "services/Redux/userToken";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import "react-toastify/dist/ReactToastify.css";
import * as Mui from "@mui/material";
import { ViewLoan } from "./ViewLoan";

export const Loans = () => {
  const { userScreenAccess } = useSelector((state) => state.tokenReducer);
  const [selectedComponent, setSelectedComponent] = React.useState(
    checkEditorPermission(userScreenAccess?.module_details, "Apply", "Loans")
      ? "Apply"
      : "history"
  );
  const [alignment, setAlignment] = useState(
    checkEditorPermission(userScreenAccess?.module_details, "Apply", "Loans")
      ? "Apply Loan"
      : "History"
  );
  const [viewLoanDetails, setViewLoanDetails] = useState({});
  const [viewLoan, setViewLoan] = useState(false);
  const dispatch = useDispatch();

  const handleChange = (event, newAlignment) => {
    if (newAlignment) {
      setAlignment(newAlignment);
    }
  };
  const renderComponent = () => {
    switch (selectedComponent) {
      case "history":
        return (
          <History
            setViewLoanDetails={setViewLoanDetails}
            setViewLoan={setViewLoan}
          />
        );
      case "Apply":
        return <Apply />;
      case "ActiveLoans":
        return (
          <ActiveLoans
            setViewLoanDetails={setViewLoanDetails}
            setViewLoan={setViewLoan}
          />
        );
      default:
        break;
    }
  };

  return (
    <React.Fragment>
      {viewLoan ? null : (
        <Mui.Grid
          container
          sx={{
            paddingTop: 2,
            paddingLeft: 3,
            flexDirection: "row",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Mui.Grid xs={4.4}>
            <Mui.Box
              sx={{
                display: "flex",
                alignItems: "center",
                width: 500,
                height: 55,
                position: "relative",
                overflow: "hidden",
              }}
            >
              <ToggleButtonGroup
                value={alignment}
                exclusive
                onChange={handleChange}
                sx={{
                  display: "flex",
                  width: "100%",
                  height: "100%",
                  position: "absolute",
                  borderRadius: "30px",
                  backgroundColor: themes.lightBrown,
                }}
              >
                {checkEditorPermission(
                  userScreenAccess?.module_details,
                  "Apply",
                  "Loans"
                ) ? (
                  <ToggleButton
                    value="Apply Loan"
                    sx={{
                      flex: 1,
                      textTransform: "capitalize",
                      fontSize: 18,
                      borderRadius: "30px",
                      fontWeight: 600,
                      border: "none",
                      color:
                        alignment === "Apply Loan"
                          ? themes.whiteColor
                          : themes.headLine,
                      backgroundColor:
                        alignment === "Apply Loan"
                          ? themes.headLine
                          : themes.lightBrown,
                      "&.Mui-selected": {
                        backgroundColor: themes.headLine,
                        color: themes.whiteColor,
                        "&:hover": {
                          backgroundColor: themes.headLine,
                          color: themes.whiteColor,
                        },
                        borderRadius: "30px",
                        "&.Mui-selected": {
                          borderRadius: "30px",
                        },
                      },
                      "&:hover": {
                        backgroundColor:
                          alignment === "Apply Loan"
                            ? themes.headLine
                            : themes.lightBrown,
                        color:
                          alignment === "Apply Loan"
                            ? themes.whiteColor
                            : themes.headLine,
                      },
                      "&:focus": {
                        backgroundColor:
                          alignment === "Apply Loan"
                            ? themes.headLine
                            : themes.lightBrown,
                        color:
                          alignment === "Apply Loan"
                            ? themes.whiteColor
                            : themes.headLine,
                      },
                    }}
                    onClick={() => {
                      setSelectedComponent("Apply");
                      dispatch(setGlobalSearchValue(""));
                    }}
                  >
                    Apply
                  </ToggleButton>
                ) : null}
                <ToggleButton
                  value="ActiveLoans"
                  sx={{
                    flex: 1,
                    textTransform: "capitalize",
                    fontSize: 18,
                    fontWeight: 600,
                    border: "none",
                    borderRadius: "30px",
                    color:
                      alignment === "ActiveLoans"
                        ? themes.whiteColor
                        : themes.headLine,
                    backgroundColor:
                      alignment === "ActiveLoans"
                        ? themes.headLine
                        : themes.lightBrown,
                    "&.Mui-selected": {
                      backgroundColor: themes.headLine,
                      color: themes.whiteColor,
                      "&:hover": {
                        backgroundColor: themes.headLine,
                        color: themes.whiteColor,
                      },
                      borderRadius: "30px",
                      "&.Mui-selected": {
                        borderRadius: "30px",
                      },
                    },
                    "&:hover": {
                      backgroundColor:
                        alignment === "ActiveLoans"
                          ? themes.headLine
                          : themes.lightBrown,
                      color:
                        alignment === "ActiveLoans"
                          ? themes.whiteColor
                          : themes.headLine,
                    },
                  }}
                  onClick={() => {
                    setSelectedComponent("ActiveLoans");
                    dispatch(setGlobalSearchValue(""));
                  }}
                >
                  Active Loans
                </ToggleButton>
                <ToggleButton
                  value="History"
                  sx={{
                    flex: 1,
                    textTransform: "capitalize",
                    fontSize: 18,
                    fontWeight: 600,
                    border: "none",
                    borderRadius: "30px",
                    color:
                      alignment === "History"
                        ? themes.whiteColor
                        : themes.headLine,
                    backgroundColor:
                      alignment === "History"
                        ? themes.headLine
                        : themes.lightBrown,
                    "&.Mui-selected": {
                      backgroundColor: themes.headLine,
                      color: themes.whiteColor,
                      "&:hover": {
                        backgroundColor: themes.headLine,
                        color: themes.whiteColor,
                      },
                      borderRadius: "30px",
                      "&.Mui-selected": {
                        borderRadius: "30px",
                      },
                    },
                    "&:hover": {
                      backgroundColor:
                        alignment === "History"
                          ? themes.headLine
                          : themes.lightBrown,
                      color:
                        alignment === "History"
                          ? themes.whiteColor
                          : themes.headLine,
                    },
                  }}
                  onClick={() => {
                    setSelectedComponent("history");
                    dispatch(setGlobalSearchValue(""));
                  }}
                >
                  History
                </ToggleButton>
              </ToggleButtonGroup>
            </Mui.Box>
          </Mui.Grid>
        </Mui.Grid>
      )}
      {viewLoan ? (
        <ViewLoan
          viewLoanDetails={viewLoanDetails}
          setViewLoan={setViewLoan}
          selectedComponent={selectedComponent}
        />
      ) : (
        renderComponent()
      )}
    </React.Fragment>
  );
};
